import { Environment } from './../environments/environment.interface';

import { InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { environment } from '@/environment';

export const LIB_CONFIG = new InjectionToken<Environment>('lib.config');

export const APP_CONFIG_VALUE: any = {
  ...environment,
};

export const provideLibConfig = () =>
  makeEnvironmentProviders([
    {
      provide: LIB_CONFIG,
      useValue: APP_CONFIG_VALUE,
    },
  ]);
